export { default } from './CurvedTitle';
